import { ThemeOpacityModel } from '../../opacity.model';

export const Opacity: ThemeOpacityModel = {
  focus: '10%',
  hover: '8%',
};
